import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CardComponent } from '../card/card.component';

@Component({
  selector: 'vectronic-show-data-and-offer-copy-dialog',
  templateUrl: './show-data-and-offer-copy-dialog.component.html',
  styleUrls: ['./show-data-and-offer-copy-dialog.component.scss'],
  imports: [CardComponent, MatDialogActions, MatButton, MatIcon, MatDialogClose],
})
export class ShowDataAndOfferCopyDialogComponent {
  dialogRef = inject(MatDialogRef<ShowDataAndOfferCopyDialogComponent>);
  data: { data: string; title: string } = inject(MAT_DIALOG_DATA);
  snackBar = inject(MatSnackBar);

  copyToClipboard() {
    navigator.clipboard.writeText(this.data.data).then(
      () => this.snackBar.open('copied to clipboard', null, { duration: 2000 }),
      () => this.snackBar.open('ERROR: unable to copy to clipboard', null, { duration: 2000 }),
    );
  }
}
